import { AdSlot } from "react-dfp";
import dynamic from "next/dynamic";

import styles from "../Advertisement.module.scss";

export const PodcastBottomAd: React.FC = () => {
  const sizes =
    window.innerWidth < 768
      ? [
          [300, 250],
          [300, 400],
          [300, 50],
        ]
      : [
          [796, 200],
          [1140, 300],
        ];

  return (
    <div className={styles.podcastBottom}>
      <AdSlot adUnit="newoncev3_podcasty2" sizes={sizes} />
    </div>
  );
};

export default dynamic(() => Promise.resolve(PodcastBottomAd), { ssr: false });
